// extracted by mini-css-extract-plugin
export default {"container":"confirmBaseChangeModal_container__AAq3o","note":"confirmBaseChangeModal_note__ozgU5"};